import http from "./httpService";
//import { showProgressBar, hideProgressBar } from "../services/uiService";


export function registration(
  usersEndPoint,
  fullNameCompany,
  nationalIDRegNum,
  email,
  mobile,
  password
) {
  var result = null;
  try {
    let userName = email;
    result = http.post(usersEndPoint + "/registration", {
      SessionId: "",
      UID: "",
      UserName: userName,
      UserPassword: password,
      NationalId: nationalIDRegNum,
      FullNameCompany: fullNameCompany,
      FirstName: "",
      LastName: "",
      Mobile: mobile,
      Email: email,
      OwnerId: 0,
      IsCompany: 0,
    });
  } catch (ex) {
    console.log("searchService.search error: " + ex);
  }

  return result;
}

export function updateUser(
  usersEndPoint,
  SID,
  UID,
  FirstName,
  LastName,
  fullNameCompany,
  NID,
  Email,
  Mobile,
  Pwd
) {
  var result = null;
  try {
    console.log("FROM SERVICE UID=" + UID);
    result = http.post(usersEndPoint + "/updateUser", {
      SessionId: SID,
      UID: UID,
      UserName: updateUser,
      UserPassword: Pwd,
      NationalId: NID,
      FirstName: FirstName,
      LastName: LastName,
      FullNameCompany: fullNameCompany,
      Mobile: Mobile,
      Email: Email,
    });
  } catch (ex) {
    console.log("searchService.search error: " + ex);
  }

  return result;
}
